import * as React from 'react'
import { Helmet } from 'react-helmet'

import CrossFitLogo from './crossfit-og-fallback.jpg'

export type Props = {
  description?: string
  image?: string
  title?: string
}

SocialMetadata.defaultProps = {
  description: '',
  image: undefined,
  title: '',
}

function SocialMetadata(props: Props) {
  const { description, image, title: titleProp } = props
  const { href, hostname, pathname } = window.location
  // Search engine optimization for social sharing mishaps
  // SSR uses /_/ prefix to render content, rectify here.
  const ssrPathname = pathname.replace('/_/', '/')
  const ssrHref = href.replace('/_/', '/')
  const url =
    hostname === 'localhost'
      ? `https://www.crossfit.com${ssrPathname}`
      : ssrHref
  const title = !titleProp ? document.title : titleProp

  return (
    <Helmet>
      <meta content='summary_large_image' name='twitter:card' />
      <meta content={title} property='og:title' />
      <meta content={url} property='og:url' />
      <meta content='article' property='og:type' />
      <meta content={description} property='og:description' />
      <meta content='@CrossFit' property='twitter:site' />
      <meta content={image || CrossFitLogo} property='og:image' />
    </Helmet>
  )
}

export default SocialMetadata
